import { CdkMenuModule } from '@angular/cdk/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  computed,
  Inject,
  inject,
  OnDestroy,
  signal,
} from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { Router, RouterOutlet } from '@angular/router';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { AuthService } from '../../services/auth.service';
import { LoginService } from '../../services/login.service';
import { DOCUMENT } from '@angular/common';
import { isDevMode } from '@angular/core';

if (isDevMode()) {
  // console.log('Modo de desenvolvimento');
} else {
  // console.log('Modo de produção');
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    RouterOutlet,
    SidenavComponent,
    OverlayModule,
    CdkMenuModule,
    CommonModule,
 ToolbarModule,
    ButtonModule,
    SidebarModule,
  ],
  template: `  <div class="app-container">
      <!-- Barra superior que preenche toda a largura -->
      <p-toolbar styleClass="custom-toolbar fixed-toolbar">
        <ng-template pTemplate="start">
          <div class="toolbar-start">
            <p-button
              (onClick)="toggleSidebar()"
              icon="pi pi-bars"
              styleClass="p-button-text p-button-plain menu-button"
              ariaLabel="Menu"
              title="Expandir/Contrair Menu">
            </p-button>
            <img src="/assets/amc-branca.png" width="150" height="50" alt="AMC Logo" />
            <div class="title">Autarquia Municipal de Trânsito e Cidadania</div>
          </div>
        </ng-template>
        <ng-template pTemplate="end">
          <div class="user">
            <div class="username">Usuário: </div>{{ shortName }}
            <p-button
              (onClick)="logout()"
              icon="pi pi-sign-out"
              styleClass="p-button-text p-button-plain"
              ariaLabel="Deslogar"
              title="Deslogar/Sair">
            </p-button>
          </div>
        </ng-template>
      </p-toolbar>
    <div class="main-container">
        <p-sidebar
          [(visible)]="sidebarVisible"
          position="left"
          [modal]="isMobile()"
          [dismissible]="isMobile()"
          [showCloseIcon]="isMobile()"
          [styleClass]="'sidebar-custom sidebar-below-toolbar ' + (collapsed() ? 'sidebar-collapsed' : 'sidebar-expanded')"
        >
          <app-sidenav [collapsed]="collapsed()"></app-sidenav>
        </p-sidebar>

        <div
          class="content"
          [style.margin-left]="!isMobile() && sidebarVisible() ? (collapsed() ? '50px' : '250px') : '0'"
        >
          <router-outlet></router-outlet>
     </div>
      </div>
    </div>`,
  styles: [
    `
   .app-container {
        height: 100vh;
        display: flex;
        flex-direction: column;
      }

      .toolbar-start {
        display: flex;
        align-items: center;
      }

       /* Barra superior fixa com largura completa */
      :host ::ng-deep .fixed-toolbar {
        position: fixed !important;
        top: 0;
        left: 0;
        right: 0;
        width: 100% !important;
        z-index: 1000;
        background-color: rgb(241, 90, 34) !important;
        color: white !important;
        height: 64px;
        min-height: 64px;
        padding: 0.5rem 1rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }

      :host ::ng-deep .fixed-toolbar .p-toolbar-group-start,
      :host ::ng-deep .fixed-toolbar .p-toolbar-group-end {
        color: white;
      }

      :host ::ng-deep .fixed-toolbar .p-button {
        color: white !important;
      }

      /* Ícone do menu sempre visível */
      :host ::ng-deep .menu-button {
        display: flex !important;
        visibility: visible !important;
      }

      /* Container principal abaixo da toolbar */
      .main-container {
        margin-top: 64px;
        height: calc(100vh - 64px);
        display: flex;
        position: relative;
      }

      /* Sidebar posicionada abaixo da toolbar */
      :host ::ng-deep .sidebar-below-toolbar {
        top: 64px !important;
        height: calc(100vh - 64px) !important;
        transition: width 500ms ease-in-out;
      }

      :host ::ng-deep .sidebar-below-toolbar .p-sidebar-content {
        padding: 0;
        height: 100%;
        overflow-x: hidden;
      }

      /* Força a largura do sidebar */
      :host ::ng-deep .sidebar-custom {
        transition: width 500ms ease-in-out !important;
        overflow: hidden !important;
      }

      :host ::ng-deep .sidebar-custom .p-sidebar-content {
        transition: width 500ms ease-in-out !important;
        overflow: hidden !important;
      }

     /* Área de conteúdo */
      .content {
        flex: 1;
        padding: 24px;
        transition: all 500ms ease-in-out;
        overflow-y: auto;
        height: calc(100vh - 64px);
        will-change: margin-left;
      }

      /* Estados específicos da sidebar */
      :host ::ng-deep .p-sidebar {
        transition: width 500ms ease-in-out !important;
      }
      
      :host ::ng-deep .sidebar-collapsed,
      :host ::ng-deep .sidebar-collapsed .p-sidebar,
      :host ::ng-deep .sidebar-collapsed .p-sidebar-content {
        width: 50px !important;
        min-width: 50px !important;
        max-width: 50px !important;
      }

      :host ::ng-deep .sidebar-expanded,
      :host ::ng-deep .sidebar-expanded .p-sidebar,
      :host ::ng-deep .sidebar-expanded .p-sidebar-content {
        width: 250px !important;
        min-width: 250px !important;
        max-width: 250px !important;
      }

      .title {
        padding-left: 10px;
        color: white;
        font-weight: 600;
      }
      
      .flex {
        display: flex;
      }
      
      .items-center {
        align-items: center;
      }
      
      .user {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: white;
      }

      .username {
        color: white;
        font-weight: 500;
      }

       /* Responsivo para mobile */
      @media (max-width: 768px) {
        :host ::ng-deep .fixed-toolbar {
          padding: 0 8px;
        }
        
        .content {
          margin-left: 0 !important;
          padding: 16px;
        }
        
        .title {
          display: none;
        }
        
        .username {
          display: none;
        }
        
        .user {
          font-size: 14px;
        }

        /* Em mobile, sidebar modal não precisa ajuste de top */
        :host ::ng-deep .sidebar-below-toolbar.p-sidebar-modal {
          top: 0 !important;
          height: 100vh !important;
        }
      }
    `,
  ],
})
export class HomeComponent implements OnDestroy {
  private resizeListener: () => void;

  authService = inject(AuthService);
  http = inject(HttpClient);
  loginService = inject(LoginService);

  isMobile = signal(false); // Novo signal para controle mobile
  isMenuOpen = signal(false); // Novo signal para estado do menu

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.checkScreenSize();
    this.resizeListener = () => this.checkScreenSize();
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeListener);
  }

  checkScreenSize() {
    const mobile = window.innerWidth < 768;
    this.isMobile.set(mobile);

    if (mobile) {
      this.collapsed.set(true);
      this.sidebarVisible.set(false); // Fecha o menu em mobile
      this.isMenuOpen.set(false); // Fecha o menu em mobile
    } else {
      this.collapsed.set(false); // Inicia expandido em desktop
      this.sidebarVisible.set(true); // Sempre visível em desktop
      this.isMenuOpen.set(true); // Mantém aberto em desktop
    }
  }

  toggleMenu() {
    if (this.isMobile()) {
      this.isMenuOpen.update((v) => !v); // Alterna estado do menu em mobile
    } else {
      this.collapsed.update((v) => !v); // Alterna colapso em desktop
    }
  }

    toggleSidebar() {
    if (this.isMobile()) {
      this.sidebarVisible.update((v) => !v); // Alterna visibilidade do sidebar em mobile
    } else {
      this.collapsed.update((v) => !v); // Alterna colapso em desktop
      // Em desktop, sidebar sempre visível, apenas muda o tamanho
    }
  }

  shortName = this.loginService.getShortName();

  logout(): void {
    /*console.log('logout');*/
    sessionStorage.setItem('auth-token', '');
    sessionStorage.setItem('shortName', '');
    sessionStorage.clear();

    // Clear cookies manually
    this.document.cookie.split(';').forEach((cookie) => {
      const [name] = cookie.split('=');
      this.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    this.authService.currentUserSig.set(null);
    this.router.navigateByUrl('login');
  }

  title = 'SICRED';
  collapsed = signal(false);
  sidebarVisible = signal(true); // Inicia visível em desktop
  sideNavWidth = computed(() => (this.collapsed() ? '50px' : '250px'));

  profilePicSize(): number {
    return 50;
  }
}
